module.exports = __webpack_public_path__ + "img/evolco-logo-dark.facb4e9b.png";